import { z } from 'zod/v4';

export const AdminUserDeleteParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminUserDeleteParams = z.infer<typeof AdminUserDeleteParamsSchema>;
